import React from 'react';
import { NativeRouter, Route, Routes } from 'react-router-native';
import { Home } from './Pages/Home';
import { ResultsPage } from './Pages/ResultsPage';
import StartPage from './Pages/StartPage';
import { EmailList } from './Pages/EmailList';

export const MyRouter = () => {
  return (
    <NativeRouter>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/results/:resultId" element={<ResultsPage/>} />
        <Route path="/email" element={<EmailList/>} />
      </Routes>
    </NativeRouter>
  );
};

